/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReimportContactJobResponseContent
 */
export interface ReimportContactJobResponseContent {
    /**
     * 
     * @type {string}
     * @memberof ReimportContactJobResponseContent
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof ReimportContactJobResponseContent
     */
    contactImportId?: string;
}


/**
 * Check if a given object implements the ReimportContactJobResponseContent interface.
 */
export function instanceOfReimportContactJobResponseContent(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReimportContactJobResponseContentFromJSON(json: any): ReimportContactJobResponseContent {
    return ReimportContactJobResponseContentFromJSONTyped(json, false);
}

export function ReimportContactJobResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReimportContactJobResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
        'contactImportId': !exists(json, 'contactImportId') ? undefined : json['contactImportId'],
    };
}

export function ReimportContactJobResponseContentToJSON(value?: ReimportContactJobResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'contactImportId': value.contactImportId,
    };
}

